module.exports = __webpack_public_path__ + "img/geodir-sodexo-logo.12c78655.png";